import { render, staticRenderFns } from "./EditOferta.vue?vue&type=template&id=154a7c68&scoped=true"
import script from "./EditOferta.vue?vue&type=script&lang=js"
export * from "./EditOferta.vue?vue&type=script&lang=js"
import style0 from "./EditOferta.vue?vue&type=style&index=0&id=154a7c68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154a7c68",
  null
  
)

export default component.exports